import PageStrings from "../../viewModels/pageStrings/pageStrings";

const usePageStrings = () => {
    return new PageStrings();
};


export default usePageStrings;